// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { getAppEnv } from "core/utils/runtimeConfig";
// import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: getAppEnv("REACT_APP_FIRE_BASE_APP_API_KEY"),
    authDomain: getAppEnv("REACT_APP_FIRE_BASE_AUTH_DOMAIN"),
    projectId: getAppEnv("REACT_APP_FIRE_BASE_PID"),
    storageBucket: getAppEnv("REACT_APP_FIRE_BASE_STORAGE_BUCKET"),
    messagingSenderId: getAppEnv("REACT_APP_FIRE_MESSAGING_SENDER_ID"),
    appId: getAppEnv("REACT_APP_FIRE_BASE_APP_ID"),
    measurementId: getAppEnv("REACT_APP_FIRE_BASE_MEASURMENT_ID"),
};

// Initialize Firebase
let messaging = null;

try {
    const firebaseApp = initializeApp(firebaseConfig);
    messaging = getMessaging(firebaseApp);
} catch (error) {
    console.warn("Firebase initialization failed. Push notifications will not work.", error);
}

export { messaging, getToken, onMessage };
